/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, makeStyles, useMediaQuery,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import { Skeleton } from '@material-ui/lab';
import Item from '../../user/components/coupon/Item';
import MagicCodeField from '../containers/MagicCodeField';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyle = makeStyles((theme) => ({
  scrollPaper: {
    alignItems: 'flex-end',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
  },
  paper: {
    height: '90%',
  },
  ItemContainer: {
    position: 'relative',

    '&+&': {
      marginTop: theme.spacing(2),
    },
  },
  magicCodeContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  sendButton: {
    borderRadius: 8,
    flexShrink: 0,
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5, 1),
  },
}));

const useLoadingItemStyle = makeStyles({
  root: {
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
});

const LoadingItem = () => {
  const classes = useLoadingItemStyle();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </div>
    </div>
  );
};

export default ({
  afterSendButtonClick,
  isLoading,
  isOpen,
  onClose,
  onCouponVoucherClick: propsOnCouponVoucherClick,
  vouchers,
}) => {
  const classes = useStyle();
  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const fullScreen = !isUpSm;
  const onCouponVoucherClick = (id) => {
    propsOnCouponVoucherClick(id);
  };

  return (
    <Dialog
      classes={{
        scrollPaper: classes.scrollPaper,
        paper: classes.paper,
      }}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      TransitionComponent={Transition}
    >
      <DialogTitle>請選擇優惠券</DialogTitle>
      <DialogContent>
        <MagicCodeField afterSendButtonClick={afterSendButtonClick} />
        {(!isLoading && isEmpty(vouchers)) && (
          <div style={{ textAlign: 'center' }}>您目前沒有可使用的優惠券</div>
        )}
        {isLoading && (
          [1, 2, 3, 4].map((value) => (
            <div className={classes.ItemContainer} key={value}>
              <LoadingItem />
            </div>
          ))
        )}
        {!isLoading && (vouchers || []).map((voucher) => {
          const { id, discount } = voucher || {};
          const disabled = discount === 0;
          return (
            <div className={classes.ItemContainer} key={id}>
              <Item
                {...voucher}
                disabled={disabled}
                onClick={disabled ? () => {} : onCouponVoucherClick}
              />
            </div>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>關閉</Button>
      </DialogActions>
    </Dialog>
  );
};
